import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Button from '@mui/material/Button'
import Badge from '@mui/material/Badge'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { useTranslation } from 'react-i18next'
import { useCart } from '../cart/CartContext'
import { formatMoney } from '../../shared/money'
import { BOTTOM_NAV_HEIGHT } from './BottomNav'

/** Sticky bottom bar; hidden while the cart is empty. Floats just above the always-on BottomNav. */
export default function CartBar({ currency, showPrices, onView }: { currency: string; showPrices: boolean; onView: () => void }) {
  const { t } = useTranslation()
  const { itemCount, subtotal } = useCart()
  if (itemCount === 0) {
    return null
  }
  return (
    <AppBar position="fixed" color="primary" sx={{ top: 'auto', bottom: `${BOTTOM_NAV_HEIGHT}px`, borderTopLeftRadius: 22, borderTopRightRadius: 22, boxShadow: '0 -4px 24px rgba(59,42,30,0.30)' }}>
      <Toolbar sx={{ gap: 2 }}>
        <Badge badgeContent={itemCount} color="error">
          <ShoppingCartIcon />
        </Badge>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            {t('cart.item', { count: itemCount })}
          </Typography>
          {/* Priceless shop (D-069): no running total. */}
          {showPrices && (
            <Typography variant="subtitle1" fontWeight={700}>
              {formatMoney(subtotal, currency)}
            </Typography>
          )}
        </Box>
        {/* Inverted button (cream on the terracotta bar) — null the theme's primary gradient so the terracotta label stays readable. */}
        <Button variant="contained" onClick={onView} sx={{ color: 'primary.main', bgcolor: 'background.paper', backgroundImage: 'none', borderRadius: '10px 10px 10px 4px', fontWeight: 700, '&:hover': { bgcolor: '#FFF8F0', backgroundImage: 'none' } }}>
          {t('cart.viewCart')}
        </Button>
      </Toolbar>
    </AppBar>
  )
}
